export default __webpack_public_path__ + "4a0e8117f93ce1b38af7e7f3b35acd47.png";